<template>
  <li
    ref="liWrapper"
    :class="{
      dragging,
      'mark-red': markTree,
      'self-temp': draggedOverKey === null,
      'hide-last-plus': hideLastPlus,
      skeleton: !node.id && node.id !== '',
    }"
    :style="styleVars" >
    <!-- @mouseleave="onDragLeave"
      @mouseenter="onDragEnter"
      @mousemove="onDragMove"
      @mouseup="onDrop" -->

    <!-- Frequency block -->
    <div
      v-if="node.type && node.type === 'frequency'"
      class="frequency flex center-all show-hand"
      @click="editFrequency" >
      <img
        :src="node.icon"
        height="12" >
      <p>{{ node.label }}</p>
    </div>

    <!-- Non split block -->
    <div
      v-else-if="!node.type || node.type !== 'split'"
      :id="node.id"
      ref="itemWrapper"
      class="item-wrapper"
      :class="{ last: !node.children || node.children.length === 0, locked: node.noMove === true, 'drag-active': dragging, 'hover-self': hoverSelf, 'self-temp': draggedOverKey === null, 'hide-last-border': !node.addAfter }"
      :data-target="node.position"
      @mouseup="onDrop" >
      <!-- + bubble after the item -->
      <!-- <div
        :style="dropPlaceholderStyle"
        :data-target="node.position"
        @mouseenter="onDragEnter" /> -->
      <span
        v-if="node.addAfter && (!dragging || node.noMove)"
        class="add"
        @click="addItem" >+</span>
      <div
        ref="itemRef"
        class="item"
        :class="{ locked: node.noMove, 'drag-active': dragging, target: Number.parseInt(draggedOverKey, 10) === node.position }"
        :data-target="node.position"
        @mousedown="dragMouseDown"
        @click="nodeClick" >
        <div
          v-if="siblingsCount > 1 && !initDragEvent"
          class="split-condition-actions flex center-all"
          @mousedown="splitActionMouse(true)"
          @mouseup="splitActionMouse(false)"
          @click="splitActionClick"
        >
          <SBIcon
            :class="{ hidden: !initDragEvent && siblingPosition === 0 }"
            class="condition-action"
            :icon="SBIconList.DOWN_ARROW"
            :color="SBColors.greyPrimary"
            :hover-icon-color="SBColors.blackPrimary"
            :size="12"
            :hover-size="22"
            pointer
            :border-color="SBColors.greyBorder"
            :border-width="1"
            :border-radius="50"
            :background-color="SBColors.white"
            :rotate="90"
            @click.native.stop="moveSibling(-1)" />
          <!-- DISABLE delete if only two -->
          <SBIcon
            :class="{ hidden: siblingsCount <= 2 && !initDragEvent && node.noDelete !== true }"
            class="condition-action ml-4 mr-4"
            :icon="SBIconList.TRASH"
            :color="SBColors.greyPrimary"
            :hover-icon-color="SBColors.blackPrimary"
            :size="12"
            :hover-size="22"
            pointer
            :border-color="SBColors.greyBorder"
            :border-width="1"
            :border-radius="50"
            :background-color="SBColors.white"
            @click.native.stop="removeFlow()"
            @mouseover.native="markTree = true"
            @mouseleave.native="markTree = false" />
          <SBIcon
            :class="{ hidden: !initDragEvent && siblingPosition === siblingsCount - 1 }"
            class="condition-action"
            :icon="SBIconList.DOWN_ARROW"
            :color="SBColors.greyPrimary"
            :hover-icon-color="SBColors.blackPrimary"
            :size="12"
            :hover-size="22"
            pointer
            :border-color="SBColors.greyBorder"
            :border-width="1"
            :border-radius="50"
            :background-color="SBColors.white"
            :rotate="-90"
            @click.native.stop="moveSibling(1)" />
        </div>
        <div class="icon-grid-wrapper flex center-all">
          <div class="icon-wrapper">
            <div class="icon" />
            <span
              v-if="siblingsCount > 1"
              class="sibling-counter" >{{ siblingPosition + 1 }}</span>
          </div>
        </div>
        <span class="condition ellipsis">{{ node.blockData && node.blockData.block_data && node.blockData.block_data.text ? node.blockData.block_data.text[0] : '' }}</span>
        <!-- <p class="label multiline-ellipsis me-2">{{ node.blockData.block_data.text[1] }}</p> -->
        <p
          class="label multiline-ellipsis me-2"
          v-html="node.blockData && node.blockData.block_data && node.blockData.block_data.text ? node.blockData.block_data.text[1] : ''" />
        <p
          v-if="node.blockData && node.blockData.block_data && node.blockData.block_data.text && node.blockData.block_data.text[2]"
          class="sublabel ellipsis">{{ node.blockData.block_data.text[2] }}</p>
        <!-- Trigger sublabel -->
        <!-- <p
          v-if="node.blockData.category === 'triggers'"
          class="sublabel ellipsis">
          <span
            v-for="(tag, index) in node.blockData.params.triggers[0].value"
            :key="index" >
            <span class="pill" >{{ tag }}</span>
            <span
              v-if="(index + 1) < node.blockData.params.triggers[0].value.length && node.blockData.params.triggers && node.blockData.params.triggers[0] && node.blockData.params.triggers[0].operator && node.blockData.params.triggers[0].operator.value"
              style="margin-right: 5px;" >{{ node.blockData.params.triggers[0].operator.value }}</span>
          </span>
        </p> -->
        <span
          v-if="node.context"
          ref="contextRef"
          class="context SB-border top" >
          <div
            class="message-wrapper outbound"
            :class="{ media: messageContentData2.attachment.mimeType }" >
            <div class="message-inner-wrapper greedy">
              <MessagePreview2 :content="messageContentData2"/>
              
              <!-- <template v-if="message.message_type === 'QUR'">
                <div
                  v-for="(button, index) in message.additional_data.items"
                  :key="index"
                  class="message-button flex center-all" >
                  {{ button.title }}
                </div>
              </template>

              <template v-if="message.message_type === 'LIS'">
                <div
                  class="message-button flex center-all" >
                  <SBIcon
                    class="mr-1"
                    :icon="SBIconList.LIST"
                    :color="SBColors.bluePrimary"
                    :size="12" />
                  <span>{{ message.additional_data.menu_title }}</span>
                </div>
              </template> -->
            </div>
          </div>
        </span>
        <SBIcon
          v-if="siblingsCount === 1 && !initDragEvent && node.noDelete !== true && node.type !== 'split-condition'"
          class="remove-item"
          :icon="SBIconList.TRASH"
          :color="SBColors.greyPrimary"
          :hover-icon-color="SBColors.blackPrimary"
          :size="12"
          :hover-size="22"
          pointer
          :border-color="SBColors.greyBorder"
          :border-width="1"
          :border-radius="50"
          :background-color="SBColors.white"
          :style="{ top: `${removeIconTop}px` }"
          @click.native.stop="removeNode()" />
      </div>

      <!-- Ghost placeholder -->
      <template v-if="showGhostPlus && !hoverSelf">
        <!-- Ghost + item -->
        <div
          ref="ghostPlusRef"
          class="ghost-plus" >
          <span class="border" />
          <span>+</span>
        </div>
        <!-- Ghost drop placeholder -->
        <div
          ref="ghostItemRef"
          class="ghost-item" />
      </template>
    </div>

    <!-- Split block -->
    <div
      v-else
      class="split-wrapper d-inline-block relative" >
      <div class="split-item">
        <div class="icon" />
        <SBIcon
          v-if="siblingsCount !== 2"
          class="remove-item"
          :icon="SBIconList.TRASH"
          :color="SBColors.greyPrimary"
          :hover-icon-color="SBColors.blackPrimary"
          :size="12"
          :hover-size="22"
          pointer
          :border-color="SBColors.greyBorder"
          :border-width="1"
          :border-radius="50"
          :background-color="SBColors.white"
          :style="{ top: `${removeIconTop}px` }"
          @click.native.stop="removeNode(true)"
          @mouseover.native="markTree = node.type === 'split'"
          @mouseleave.native="markTree = false" />
      </div>
    </div>

    <div
      ref="rightPlusRef"
      class="d-none right-plus position-absolute"
      @click="appendChild(parentNodeId)">+</div>
    <div
      ref="leftPlusRef"
      class="d-none left-plus position-absolute"
      @click="prependChild(parentNodeId)">+</div>

    <!-- Drag item -->
    <div
      :id="`drag-item-${node.position}`"
      :ref="`drag-item-${node.position}`"
      class="item ghost" >
      <!-- Icon -->
      <div class="icon-grid-wrapper flex center-all">
        <div class="icon-wrapper">
          <div class="icon" />
          <span
            v-if="siblingsCount > 1"
            class="sibling-counter" >{{ siblingPosition + 1 }}</span>
        </div>
      </div>
      <!-- Condition -->
      <span class="condition ellipsis">{{ node.blockData && node.blockData.block_data && node.blockData.block_data.text ? node.blockData.block_data.text[0] : '' }}</span>
      <!-- Label -->
      <p
        class="label multiline-ellipsis me-2"
        v-html="node.blockData && node.blockData.block_data && node.blockData.block_data.text ? node.blockData.block_data.text[1] : ''" />
      <p
        v-if="node.blockData && node.blockData.block_data && node.blockData.block_data.text && node.blockData.block_data.text[2]"
        class="sublabel ellipsis">{{ node.blockData.block_data.text[2] }}</p>
      <!-- Context -->
      <span
        v-if="node.context"
        class="context SB-border top" >
        <div
          class="message-wrapper outbound"
          :class="{ media: messageContentData2.attachment.mimeType }" >
          <div class="message-inner-wrapper greedy">
            <MessagePreview2 :content="messageContentData2"/>
            
            <!-- <template v-if="message.message_type === 'QUR'">
              <div
                v-for="(button, index) in message.additional_data.items"
                :key="index"
                class="message-button flex center-all" >
                {{ button.title }}
              </div>
            </template>

            <template v-if="message.message_type === 'LIS'">
              <div
                class="message-button flex center-all" >
                <SBIcon
                  class="mr-1"
                  :icon="SBIconList.LIST"
                  :color="SBColors.bluePrimary"
                  :size="12" />
                <span>{{ message.additional_data.menu_title }}</span>
              </div>
            </template> -->
          </div>
        </div>
      </span>
    </div>

    <ul
      v-if="node.children && node.children.length"
      :class="{
        'drag-active': dragging && node.noMove === true,
        'self-temp': draggedOverKey === null,
        'split-mode': node.type === 'split',
        'maxed-out': node.children && flowsDefinitionsUI.logic.SPLIT.limits.max_child_flows === node.children.length,
      }" >
      <FlowNode
        v-for="(n, i) in node.children"
        :key="i"
        :node="n"
        :parent-node-id="node.id"
        :scale="scale"
        :auto-scroll-offset="autoScrollOffset"
        :auto-scroll-active="autoScrollActive"
        :positions="positions"
        :update-position="updatePosition"
        :wrapper-offset="wrapperOffset"
        :siblings-count="node.children.length"
        :sibling-position="i" />
    </ul>

    <!-- This hides the line and goes under the item element to preserve shadow -->
    <div
      v-if="!node.children || node.children.length === 0"
      class="hide-last-border" />
    <!-- This hides plus element -->
    <div
      v-if="!node.children || node.children.length === 0"
      class="hide-last-plus" />
    <div class="column-width" />
  </li>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import MessageContent from '@/components/common/MessageContent';
import ToasterMixin from '@/mixins/Toaster';
import {
  getFileExtension,
  getMediaTypeFromExtension,
  getMediaType,
  getMediaName,
} from '@/helpers/mediaHelpers';
import MessagePreview2 from '@/components/common/MessagePreview2';

export default {
  name: 'FlowNode',
  components: {
    MessageContent,
    MessagePreview2,
  },
  mixins: [
    ToasterMixin,
  ],
  props: {
    node: {
      type: Object,
      required: true,
      default: () => {},
    },
    parentNodeId: {
      type: String,
      required: false,
      default: null,
    },
    scale: {
      type: Number,
      required: false,
      default: 1,
    },
    autoScrollOffset: {
      type: Object,
      required: false,
      default: () => {},
    },
    autoScrollActive: {
      type: Boolean,
      required: false,
      default: false,
    },
    positions: {
      type: Object,
      required: false,
      default: () => {},
    },
    wrapperOffset: {
      type: Object,
      required: false,
      default: () => {},
    },
    updatePosition: {
      type: Number,
      required: false,
      default: 0,
    },
    siblingsCount: {
      type: Number,
      required: false,
      default: 1,
    },
    siblingPosition: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      dragging: false,
      dragEl: null,
      dragOverTop: null,
      initDragEvent: null,
      hoverSelf: false,
      previousDragEvent: null,
      preventEdit: false,
      direction: null,
      markTree: false,
      hideLastPlus: false,
      removeIconTop: 0,
      items: [],
      itemsRects: {},
      ignoreDrag: false,
      showTest: true,
    };
  },
  computed: {
    ...mapGetters({
      draggedOverKey: 'helpers/draggedOverKey',
      flowsDefinitionsUI: 'flows/flowsDefinitionsUI',
      flowsDefinitions: 'flows/flowsDefinitions',
      blocksCount: 'flows/blocksCount',
    }),





    //////// TODO remove on refactor
    messageContentData() {
      let media;
      let mimeType;
      try {
        media = this.node.blockData.params.elements.find(e => e.type === 'media_url').value;
        mimeType = this.node.blockData.params.elements.find(e => e.type === 'mime_type').value;
      } catch (error) {
        media = null;
        mimeType = null;
      }
      return {
        type: 'text',
        text: this.node.context ? this.node.context : '',
        media,
        mimeType,
        // attachmentType: this.selectedTemplateLanguageVersion ? this.selectedTemplateLanguageVersion.attachment : null,
        // attachment: this.formData.has('file') ? this.formData.get('file') : '',
      };
    },
    messageContentData2() {
      let url;
      let name;
      let mimeType;
      let attachmentType;
      let buttons;
      let menu;
      try {
        url = this.node.blockData.params.elements.find(e => e.type === 'media_url').value.media_url;
        mimeType = this.node.blockData.params.elements.find(e => e.type === 'mime_type').value;
        attachmentType = getMediaType(mimeType);
        name = getMediaName(url);
      } catch (error) {
        url = null;
        mimeType = null;
        name = '';
        attachmentType = null;
      }
      try {
        buttons = this.node.blockData.params.elements.find(e => e.type === 'buttons').value;
      } catch (error) {
        buttons = null;
      }
      try {
        menu = this.node.blockData.params.elements.find(e => e.type === 'menu_list').value;
      } catch (error) {
        menu = null;
      }
      return {
        text: this.node.context ? this.node.context : '',
        attachmentType,
        attachment: {
          mimeType,
          name,
          url,
        },
        buttons,
        menu,
      };
    },
    maxBlocksUsed() {
      // -1 because we are not counting trigger block
      return this.flowsDefinitions && this.flowsDefinitions.flows && (this.blocksCount.total - 1) >= this.flowsDefinitions.flows.rules.BLOCKS_PER_FLOW;
    },
    showGhostPlus() {
      return Number.parseInt(this.draggedOverKey, 10) === this.node.position;
    },
    dropPlaceholderStyle() {
      return {
        position: 'absolute',
        height: this.node.children && this.node.children.length > 1 ? '60px' : '50px',
        width: '100%',
        left: '0px',
        bottom: this.node.children && this.node.children.length > 1 ? '-60px' : '-50px',
        'z-index': '2',
      };
    },
    styleVars() {
      return {
        '--icon': this.node.icon,
        '--icon-bg-color': this.node.iconBgColor,
        '--icon-data': `url(${this.node.icon})`,
      };
    },
  },
  watch: {
    autoScrollActive() {
      // this.onDragLeave();
    },
    autoScrollOffset() {
      if (!this.dragEl) {
        return;
      }
      this.dragEl.style.top = `${(Number.parseInt(this.dragEl.style.top, 10) + this.autoScrollOffset.up)}px`;
      this.dragEl.style.left = `${(Number.parseInt(this.dragEl.style.left, 10) + this.autoScrollOffset.left)}px`;
    },
    draggedOverKey() {
      if (!this.node || !this.$refs.itemWrapper) return;
      if (Number.parseInt(this.draggedOverKey, 10) === this.node.position) {
        this.$refs.itemWrapper.classList.add('drag-over');
        if (!this.$refs.itemWrapper.dataset.tempHeight || this.$refs.itemWrapper.dataset.tempHeight === 'false') {
          this.$refs.itemWrapper.style.height = `${this.$refs.itemWrapper.offsetHeight + JSON.parse(localStorage.getItem('SBdragging')).height + (50 * this.scale)}px`; // 50 is the height of a + element
          this.$refs.itemWrapper.dataset.tempHeight = true;
        }
      } else {
        this.$refs.itemWrapper.style.height = 'unset';
        this.$refs.itemWrapper.dataset.tempHeight = false;
      }

      if (this.autoScrollActive) return;
      this.$nextTick(() => {
        this.mouseMoveAction();
      });
    },
    updatePosition() {
      this.hoverSelf = JSON.parse(localStorage.getItem('SBdragging')).position === this.node.position;
      this.mouseMoveAction();
    },
  },
  mounted() {
    // This is just in case drag and drop was not closed properly so it can be reset on reload or changing screens.
    // We can't delete the localStorage item on closeDragElement because it will be called after the drop event and each time after a drop it is being rerendered with new structure.
    const tempLS = JSON.parse(localStorage.getItem('SBdragging'));
    if (tempLS && tempLS.active) {
      tempLS.active = false;
      localStorage.setItem('SBdragging', JSON.stringify(tempLS));
    }

    const itemHeight = this.$refs.itemRef && this.$refs.itemRef.offsetHeight ? this.$refs.itemRef.offsetHeight : 0;
    const contextHeight = this.$refs.contextRef && this.$refs.contextRef ? this.$refs.contextRef.offsetHeight : 0;
    this.removeIconTop = ((itemHeight - contextHeight) / 2) - 11;

    window.addEventListener('contextmenu', () => {
      if (this.dragging) {
        this.reset();
      }
    });
    window.addEventListener('mouseup', () => {
      this.reset();
      setTimeout(() => {
        this.mouseMoveAction();
      }, 100);
    });
  },
  methods: {
    ...mapActions({
      setDraggedOverKey: 'helpers/draggedOverKey',
      updateFlowFrequency: 'flows/updateFlowFrequency',
      moveSiblingFlowBlock: 'flows/moveSiblingFlowBlock',
      removeFlowVUEX: 'flows/removeFlow',
    }),
    getFileExtension,
    getMediaTypeFromExtension,
    addItem() {
      this.$eventBus.$emit('addNodeModal', {
        node: this.node,
      });
    },
    appendChild(parentNodeId) {
      if (this.maxBlocksUsed) {
        this.showToaster('Max number of blocks used.', null, null, 'warning');
        return;
      }
      this.$eventBus.$emit('addNodeModal', {
        node: this.node,
        forceType: 'filter',
        sibling: 'after',
        targetNodeId: parentNodeId,
        mode: 'add',
      });
    },
    editFrequency() {
      this.$eventBus.$emit('showFlowFrequencyModal', {
        type: this.node.frequencyType,
        value: this.node.value,
        confirmCallback: this.updateFrequency,
      });
    },
    updateFrequency(params) {
      return new Promise((resolve, reject) => {
        const data = {
          numberId: this.$route.params.numberId,
          flowId: this.$route.params.flowId,
          type: params.frequency.value,
        };
        if (params.time && params.time.seconds) {
          data.value = params.time.seconds;
        }
        this.updateFlowFrequency(data)
          .then(() => {
            window.eventBus.$emit('updateFrequency', {
              type: params.frequency.value,
              value: data.value,
            });
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    editNode() {
      if (this.node.type === 'trigger') {
        this.$eventBus.$emit('showFlowNodeModal', {
          node: this.node,
        });
      } else {
        this.$eventBus.$emit('addNodeModal', {
          node: this.node,
          forceType: this.node.blockData.type,
          mode: 'edit',
        });
      }
    },
    prependChild(parentNodeId) {
      if (this.maxBlocksUsed) {
        this.showToaster('Max number of blocks used.', null, null, 'warning');
        return;
      }
      this.$eventBus.$emit('addNodeModal', {
        node: this.node,
        forceType: 'filter',
        sibling: 'before',
        targetNodeId: parentNodeId,
      });
    },
    removeFlow() {
      this.$confirmPluginModal.show({
        buttonVariant: 'RED',
        title: 'Delete path',
        message: 'Are you sure you want to delete this path?',
        confirmButtonText: 'Delete',
        showUndoWarning: true,
        autoClose: false,
        confirmCallback: () => {
          this.removeFlowVUEX({
            node: this.node,
            parentNodeId: this.parentNodeId,
          });
        },
      });
    },
    removeNode(removeChildren = false) {
      this.$confirmPluginModal.show({
        buttonVariant: 'RED',
        title: 'Delete block',
        message: this.node.type === 'split' ? 'Are you sure you want to delete the selected blocks?' : 'Are you sure you want to delete this block?',
        confirmButtonText: 'Delete',
        showUndoWarning: true,
        autoClose: false,
        confirmCallback: () => {
          this.$eventBus.$emit('flow-remove', {
            node: this.node,
            itemPosition: this.node.position,
            removeChildren,
            parentNodeId: this.parentNodeId,
          });
        },
      });
    },
    /**
     * Moves sibling block left or right
     * @param {Number} direction Updates sibling position by -1 or +1 depending on the direction it needs to move
     */
    moveSibling(direction) {
      this.moveSiblingFlowBlock({
        direction,
        node: this.node,
        parentNodeId: this.parentNodeId,
      });
    },
    mouseMoveAction() {
      if (!this.$refs.itemRef) return;
      if (this.showGhostPlus && this.$refs.ghostPlusRef) {
        const itemHeight = this.$refs.itemRef.offsetHeight;
        this.$refs.ghostPlusRef.style.top = `${itemHeight + 15}px`;
        const SBdragging = JSON.parse(localStorage.getItem('SBdragging'));
        this.$refs.ghostItemRef.style.height = `${SBdragging.height}px`;

        const dropOnTop = localStorage.getItem('SBdragoverLocation');
        if (this.node.dropBelow === false || (dropOnTop === 'before' && this.node.dropAbove !== false)) {
          this.$refs.ghostPlusRef.style.top = `${SBdragging.height + (15 * this.scale)}px`;
          this.$refs.itemRef.style.top = `${SBdragging.height + (50 * this.scale)}px`;
          this.$refs.ghostItemRef.style.top = '0px';
        } else {
          this.$refs.ghostPlusRef.style.top = `${itemHeight + (15 * this.scale)}px`;
          this.$refs.itemRef.style.top = '0px';
          this.$refs.ghostItemRef.style.top = `${itemHeight + (50 * this.scale)}px`;
        }
      } else {
        this.$refs.itemRef.style.top = 'unset';
      }
    },
    reset() {
      this.hideLastPlus = false;
      this.setDraggedOverKey(null);
      this.dragging = false;
      this.$eventBus.$emit('flow-drag-end');
      const tempLS = JSON.parse(localStorage.getItem('SBdragging'));
      if (tempLS && tempLS.active) {
        tempLS.active = false;
      }
      localStorage.setItem('SBdragging', JSON.stringify(tempLS));
      try {
        this.dragEl.style.display = 'none';
      } catch (error) {
        console.warn('Error while hiding the ghost element', error);
      }
      this.initDragEvent = null;
      document.onmouseup = null;
      document.onmousemove = null;
    },
    dragMouseDown(event) {
      if (
        this.ignoreDrag ||
        !this.node ||
        event.button !== 0
      ) return;
      // event.preventDefault();
      event.stopPropagation();
      if ( // clicked on the remove icon
        event.target.classList.contains('remove-item') ||
        event.target.parentElement.classList.contains('remove-item')
      ) {
        return;
      }

      this.initDragEvent = event;
      document.onmousemove = this.elementDrag;
      document.onmouseup = this.closeDragElement;

      if (
        this.node.noMove ||
        this.siblingsCount > 1
      ) {
        // this.showToaster('This block can\'t be moved.', null, 'danger', 'warning');
        return;
      }


      // set the ghost on top to be dragged
      this.dragEl = this.$refs[`drag-item-${this.node.position}`];
      // this.dragEl.style.display = 'grid';
      // this.dragEl.style.top = `${(this.positions.y - this.positions.wrapperY - this.wrapperOffset.top - this.initDragEvent.layerY - 1)}px`;
      // this.dragEl.style.left = `${(this.positions.x - this.positions.wrapperX - this.wrapperOffset.left - this.initDragEvent.layerX - 0)}px`;

      localStorage.setItem('SBdragging', JSON.stringify({
        ...this.node,
        height: this.$refs.itemWrapper.offsetHeight,
        top: event.target.offsetTop - this.$refs[`drag-item-${this.node.position}`].offsetHeight,
        active: false,
      }));
    },
    elementDrag(event) {
      event.preventDefault();
      if (this.dragging && (!this.node.children || this.node.children.length === 0)) {
        this.hideLastPlus = true;
      }
      if (this.previousDragEvent && this.previousDragEvent.clientY < event.clientY) {
        this.direction = 'DOWN';
      } else if (this.previousDragEvent && this.previousDragEvent.clientY > event.clientY) {
        this.direction = 'UP';
      }
      localStorage.setItem('SBDragDirection', this.direction);
      // Start dragging only if it moves for more than 10px
      if (
        !this.dragging &&
        (
          Math.abs(event.clientY - this.initDragEvent.clientY) > 10 ||
          Math.abs(event.clientX - this.initDragEvent.clientX) > 10
        )
      ) {
        if (
          this.node.noMove ||
          this.siblingsCount > 1
        ) {
          this.showToaster('This block can\'t be moved.', null, 'danger', 'warning');
          this.preventEdit = true;
          document.onmousemove = null;
          this.closeDragElement();
          return;
        }
        this.$eventBus.$emit('flow-drag-start', this.node.position);
        const tempLS = JSON.parse(localStorage.getItem('SBdragging'));
        if (tempLS && !tempLS.active) {
          tempLS.active = true;
        }
        localStorage.setItem('SBdragging', JSON.stringify(tempLS));
        this.dragging = true;
      }

      if (this.dragging) {
        // const correctionFactor = 1 / this.scale;
        this.dragEl.style.display = 'grid';
        this.dragEl.style.top = `${(this.positions.y - this.positions.wrapperY - this.wrapperOffset.top - this.initDragEvent.layerY - 1)}px`;
        this.dragEl.style.left = `${(this.positions.x - this.positions.wrapperX - this.wrapperOffset.left - this.initDragEvent.layerX - 1)}px`;
        this.$eventBus.$emit('flow-dragging', this.node.position);

        // console.log('dragging innn', this.node.position, this.showGhostPlus, this.$refs.ghostPlusRef);

        // if (this.showGhostPlus) {
        //   const SBdragging = JSON.parse(localStorage.getItem('SBdragging'));
        //   const itemHeight = this.$refs.itemRef.offsetHeight;
        //   const dropOnTop = localStorage.getItem('SBdragoverLocation');
        //   if (dropOnTop === 'before') {
        //     console.log('BEFORE');
        //     this.$refs.ghostPlusRef.style.top = `${SBdragging.height + (15 * this.scale)}px`;
        //     this.$refs.itemRef.style.top = `${SBdragging.height + (50 * this.scale)}px`;
        //     this.$refs.ghostItemRef.style.top = '0px';
        //     // localStorage.setItem('SBdragoverLocation', 'before');
        //   } else {
        //     console.log('AFTER');
        //     this.$refs.ghostPlusRef.style.top = `${itemHeight + (15 * this.scale)}px`;
        //     this.$refs.itemRef.style.top = '0px';
        //     this.$refs.ghostItemRef.style.top = `${itemHeight + (50 * this.scale)}px`;
        //     // localStorage.setItem('SBdragoverLocation', 'after');
        //   }
        // }
        

        // set the ghost item on top or bottom
        // if (this.showGhostPlus && this.$refs.ghostPlusRef) {
        //   console.log('qqq');
        //   const itemHeight = this.$refs.itemRef.offsetHeight;
        //   this.$refs.ghostPlusRef.style.top = `${itemHeight + 15}px`;
        //   const posOverBase = event.pageY - this.dragOverTop;
        //   const dropOnTop = Number.parseInt(this.$refs.itemWrapper.style.height, 10) / 2 > posOverBase;
        //   // console.log('BASE:::', dropOnTop, posOverBase, Number.parseInt(this.$refs.itemWrapper.style.height, 10), Number.parseInt(this.$refs.itemWrapper.style.height, 10) / 2 > posOverBase ? 'TOP' : 'BOTTOM');
        //   const SBdragging = JSON.parse(localStorage.getItem('SBdragging'));
        //   this.$refs.ghostItemRef.style.height = `${SBdragging.height}px`;

        //   if (dropOnTop) {
        //     this.$refs.ghostPlusRef.style.top = `${SBdragging.height + (15 * this.scale)}px`;
        //     this.$refs.itemRef.style.top = `${SBdragging.height + (50 * this.scale)}px`;
        //     this.$refs.ghostItemRef.style.top = '0px';
        //     localStorage.setItem('SBdragoverLocation', 'before');
        //   } else {
        //     this.$refs.ghostPlusRef.style.top = `${itemHeight + (15 * this.scale)}px`;
        //     this.$refs.itemRef.style.top = '0px';
        //     this.$refs.ghostItemRef.style.top = `${itemHeight + (50 * this.scale)}px`;
        //     localStorage.setItem('SBdragoverLocation', 'after');
        //   }
        // }

        // const boundingRectData = this.dragEl.getBoundingClientRect();
        // console.dir(boundingRectData);

        // let foundTarget = false;
        // Object.keys(this.itemsRects).some((irKey) => {
        //   if (
        //     (
        //       (this.itemsRects[irKey].bottom > boundingRectData.top && this.itemsRects[irKey].top < boundingRectData.top) ||
        //       (this.itemsRects[irKey].top < boundingRectData.bottom && this.itemsRects[irKey].bottom > boundingRectData.bottom)
        //     ) &&
        //     (
        //       (this.itemsRects[irKey].right > (boundingRectData.left + (boundingRectData.width / 2)) && this.itemsRects[irKey].left < (boundingRectData.left + (boundingRectData.width / 2))) ||
        //       (this.itemsRects[irKey].left < (boundingRectData.right - (boundingRectData.width / 2)) && this.itemsRects[irKey].right > (boundingRectData.right - (boundingRectData.width / 2)))
        //     )
        //   ) {
        //     console.log('OVER', irKey);
        //     this.setDraggedOverKey(irKey);
        //     foundTarget = true;
        //     return true;
        //   }
        //   return false;
        // });

        // if (!foundTarget) {
        //   this.setDraggedOverKey(null);
        // }
      }
      this.previousDragEvent = event;
    },
    closeDragElement() {
      this.hideLastPlus = false;
      this.setDraggedOverKey(null);
      this.dragging = false;
      const tempLS = JSON.parse(localStorage.getItem('SBdragging'));
      if (tempLS && tempLS.active) {
        tempLS.active = false;
      }
      localStorage.setItem('SBdragging', JSON.stringify(tempLS));
      if (this.dragEl) this.dragEl.style.display = 'none';
      this.initDragEvent = null;
      document.onmouseup = null;
      document.onmousemove = null;
      // const SBdragging = JSON.parse(localStorage.getItem('SBdragging'));
      // if (SBdragging.movable === false) {
      //   this.showToaster('This block can\'t be moved.', null, 'danger', 'error');
      // }
    },
    onDragEnter(event) {
      if (!this.node) return;
      const SBdragging = JSON.parse(localStorage.getItem('SBdragging'));
      if (!SBdragging || !SBdragging.active || SBdragging.position === this.node.position) {
        this.hoverSelf = true;
      }
      if (
        (this.autoScrollActive) ||
        (SBdragging && SBdragging.noMove) ||
        (!SBdragging || !SBdragging.active || SBdragging.position === this.node.position)
      ) {
        return;
      }
      const itemHeight = this.$refs.itemRef.offsetHeight;
      // console.log('OVERRRRRR', this.$refs.itemRef.offsetHeight);
      // console.dir(this.$refs.itemRef.getBoundingClientRect());
      this.dragOverTop = this.$refs.itemRef.getBoundingClientRect().top;
      // this.showGhostPlus = true;

      localStorage.setItem('SBdragover', event.target.dataset.target);

      this.$refs.itemWrapper.classList.add('drag-over');
      if (!this.$refs.itemWrapper.dataset.tempHeight || this.$refs.itemWrapper.dataset.tempHeight === 'false') {
        // console.log('BIG', event.target.offsetHeight, JSON.parse(localStorage.getItem('SBdragging')).height);
        this.$refs.itemWrapper.style.height = `${event.target.offsetHeight + JSON.parse(localStorage.getItem('SBdragging')).height + (50 * this.scale)}px`; // 50 is the height of a + element
        this.$refs.itemWrapper.dataset.tempHeight = true;
      }
    },
    onDragLeave() {
      this.hoverSelf = false;
      // this.showGhostPlus = false;
      localStorage.removeItem('SBdragover');
      localStorage.removeItem('SBdragoverLocation');
      this.$refs.itemWrapper.classList.remove('drag-over');
      const SBdragging = JSON.parse(localStorage.getItem('SBdragging'));
      if (SBdragging && SBdragging.active && SBdragging.position !== this.node.position) {
        // const wrapperHeight = Number.parseInt(this.$refs.itemWrapper.style.height.replace('px', ''), 10);
        // console.log('SMALL', wrapperHeight, SBdragging.height);
        // this.$refs.itemWrapper.style.height = `${wrapperHeight - SBdragging.height - (50 * this.scale)}px`;
        this.$refs.itemWrapper.style.height = 'unset';
        this.$refs.itemWrapper.dataset.tempHeight = false;
      }

      this.dragOverTop = null;
      this.$refs.itemRef.style.top = '0px';
    },
    onDragMove(e) {
      if (this.autoScrollActive) return;
      if (this.showGhostPlus && this.$refs.ghostPlusRef) {
        const itemHeight = this.$refs.itemRef.offsetHeight;
        this.$refs.ghostPlusRef.style.top = `${itemHeight + 15}px`;
        const posOverBase = e.pageY - this.dragOverTop;
        const dropOnTop = Number.parseInt(this.$refs.itemWrapper.style.height, 10) / 2 > posOverBase;
        // console.log('BASE:::', dropOnTop, posOverBase, Number.parseInt(this.$refs.itemWrapper.style.height, 10), Number.parseInt(this.$refs.itemWrapper.style.height, 10) / 2 > posOverBase ? 'TOP' : 'BOTTOM');
        const SBdragging = JSON.parse(localStorage.getItem('SBdragging'));
        this.$refs.ghostItemRef.style.height = `${SBdragging.height}px`;

        if (dropOnTop) {
          this.$refs.ghostPlusRef.style.top = `${SBdragging.height + (15 * this.scale)}px`;
          this.$refs.itemRef.style.top = `${SBdragging.height + (50 * this.scale)}px`;
          this.$refs.ghostItemRef.style.top = '0px';
          localStorage.setItem('SBdragoverLocation', 'before');
        } else {
          this.$refs.ghostPlusRef.style.top = `${itemHeight + (15 * this.scale)}px`;
          this.$refs.itemRef.style.top = '0px';
          this.$refs.ghostItemRef.style.top = `${itemHeight + (50 * this.scale)}px`;
          localStorage.setItem('SBdragoverLocation', 'after');
        }
      }
    },
    nodeClick() {
      if (!this.dragging && !this.preventEdit) {
        this.editNode();
      }
    },
    onDrop() {
      if (!this.node) return;
      if (!this.dragging && this.preventEdit) {
        return;
      }
      this.preventEdit = false;
      const SBdragging = JSON.parse(localStorage.getItem('SBdragging'));
      if (SBdragging && SBdragging.noMove) {
        this.$eventBus.$emit('flow-drop', {});
        return;
      }
      const target = Number.parseInt(this.draggedOverKey, 10);
      if (!target || !SBdragging || !SBdragging.active) {
        this.$eventBus.$emit('flow-drop', {});
        return;
      }
      delete SBdragging.height;
      delete SBdragging.top;
      delete SBdragging.active;
      delete SBdragging.children;
      this.$eventBus.$emit('flow-drop', {
        target,
        above: localStorage.getItem('SBdragoverLocation') === 'before' && this.node.dropAbove !== false,
        dropped: SBdragging,
      });
      this.onDragLeave();
    },
    /** Prevents edit modal from triggering */
    splitActionClick(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    /**
     * Sets ignore drag flag so the drag event doesn't trigger on the underlying element.
     * @param {Boolean} ignore If true, it will ignore the drag action.
     */
    splitActionMouse(ignore = false) {
      this.ignoreDrag = ignore;
    },
  },
};
</script>

<style lang="scss" scoped>
.frequency {
  max-width: fit-content;
  margin: 0 auto;
  padding: 6px 12px 5px 12.3px;
  object-fit: contain;
  border-radius: 18px;
  box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.07);
  border: solid 1px $greyBorder;
  background-color: #f7fdff;

  .sb-icon {
    margin-left: -2px;
  }

  p {
    margin-left: 6px;
    font-size: 12px;
    font-weight: 500;
    color: #54626c;
  }

  &:hover {
    * {
      color: $blackPrimary !important;
    }
    img {
      // Can't change the image color even if it's svg so this hack had to be used
      filter: brightness(0);
    }
  }
}

.item-wrapper {
  position: relative;
  // background: lightyellow;

  &.last:not(.hide-last-border)::after, &.self-temp:not(.hide-last-border)::after {
    content: '';
    position: absolute;
    bottom: -50px;
    left: 50%;
    border-left: 1px solid #ccc;
    width: 0;
    height: 50px;
  }

  &.last:not(.hide-last-border)::after {
    bottom: -25px;
    height: 25px;
  }

  &.drag-active {
    .locked {
      // background-color: red;
    }

    &.last:not(.hide-last-border), &.self-temp:not(.hide-last-border) {
      opacity: 1;
      height: unset !important;

      .add, &:after, .item * {
        opacity: 0;
      }
    }

    &.self-temp:not(.hide-last-border) {
      .add, &:after {
        opacity: 1;
      }
      // margin-bottom: 50px;
    }

    &.self-temp.last:not(.hide-last-border) {
      .add, &:after, .item * {
        opacity: 0;
      }
    }

    &.hover-self {
      opacity: 1;
    }

    &:not(.locked):not(.self-temp) {  // :not(.last) // add this if you want not to hile last while dragging
      display: none;
    }
  }

  span.add {
    position: absolute;
    bottom: -35px;
    left: calc(50% - 10px);
    border: 1px solid #ccc;
    border-radius: 10px;
    width: 20px;
    height: 20px;
    background: $white;
    cursor: pointer;
    z-index: 2;

    &:hover {
      box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.3);
    }
  }

  .ghost-plus {
    position: absolute;
    left: calc(50% - 10px);

    span {
      display: block;
      position: absolute;
      border: 1px solid #ccc;
      border-radius: 10px;
      width: 20px;
      height: 20px;
      background: $white;
      cursor: pointer;
      z-index: 2;
    }

    .border {
      content: '';
      top: -15px;
      left: 9px;
      border: none;
      border-left: 1px solid #ccc;
      width: 0;
      height: 50px;
      z-index: 2;
    }
  }

  .ghost-item {
    position: absolute;
    left: calc(50% - 176.5px);
    top: 0;
    width: 353px;
    // height: 50px !important; // Height is calculated dinamically based on the element being dragged
    background: $grayHover;
    border-radius: 18px;
  }
}

.item {
  position: relative;
  z-index: 2;
  width: 353px;
  cursor: pointer;
  display: inline-grid;
  border-radius: 18px;
  box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.15);
  border: 1px solid $greyBorder;
  background-color: $white;
  user-select: none;
  grid-template-columns: 12px [first] 40px [line2] 7px auto [line3] 12px;
  grid-template-rows: 12px [row1-start] minmax(20px, auto) [row1-end] minmax(20px, auto) [third-line] minmax(0px, auto) [forth-line] 12px auto [last-line];
  grid-template-areas:
    ". . . . ."
    ". icon-grid-wrapper . condition ."
    ". icon-grid-wrapper . label ."
    ". icon-grid-wrapper . sublabel ."
    ". . . . ."
    "context context context context context";

  &:active {
    cursor: grab;
  }

  &.locked {
    // background-color: lightpink;
    // cursor: default;
  }

  .split-condition-actions {
    cursor: default;
    display: flex !important;
    position: absolute;
    top: -42px;
    height: 42px;
    width: 100%;
    opacity: 0;
    // background: red;

    .condition-action {
      display: flex;
      &:hover {
        box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.3);
      }
    }

    .hidden {
      visibility: hidden !important;
    }
  }

  &.ghost {
    // background-color: lightblue;
    position: fixed;
    display: none;
    top: 0px;
    left: 0px;
    pointer-events: none;
    z-index: 99;
  }

  &.drag-active:not(.locked) {
    * {
      // visibility: hidden;
    }

    background: $grayHover;
    border: 1px solid $grayHover;
  }

  &.target {
    // background-color: green;
    // border: 1px solid $grayHover;
  }

  .remove-item {
    position: absolute;
    right: -11px;
    display: none;
    box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1);

    &:hover {
      box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.3);
    }
  }

  &:hover {
    .remove-item {
      display: flex;
    }

    .split-condition-actions {
      opacity: 1 !important;
    }
  }
}

#flow-wrapper.dragging {
  .item {
    .remove-item {
      display: none !important;
    }
  }
}

li {
  &.dragging:not(.self-temp) {
    margin: -50px 0 !important;
  }
}

.icon-grid-wrapper {
  grid-area: icon-grid-wrapper;

  .icon-wrapper {
    position: relative;

    .sibling-counter {
      position: absolute;
      top: 21px;
      left: 25px;
      font-size: 14px;
      font-weight: 500;
      color: #c11e1e;
    }
  }
}

.icon {
  grid-area: icon;
  margin: 0;
  padding: 10px;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 0 3px 0 rgba(48, 54, 70, 0.16);
  border: solid 1px $greyBorder;
  background-image: var(--icon-data);
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: center;
  background-color: var(--icon-bg-color); // #f9f5fc;
  width: 40px;
  height: 40px;
  justify-self: center;
  align-self: center;

  &.split {
    background-color: #fff8fe;
  }
}

.condition, .label {
  justify-self: start;
  text-align: start;
  max-width: 100%;
}

.condition {
  grid-area: condition;
  align-self: end;
  font-size: 12px;
  font-weight: 400;
  color: #54626c;
  align-self: center;
}

.label {
  grid-area: label;
  align-self: start;
  font-size: 14px;
  font-weight: 500;
  color: $blackPrimary;
  padding-top: 1px;
  line-height: 1.2;
}

.sublabel {
  grid-area: sublabel;
  align-self: start;
  line-height: 1.2;
  justify-self: start;
  text-align: start;
  max-width: 100%;

  font-weight: 500;
  font-size: 12px;
  color: #54626c;
  margin-top: 4px;
}

.context {
  grid-area: context;
  padding: 12px;

  .message {
    background-color: #DFEEFF;
    border-radius: 8px;
    padding: 5px;
    width: fit-content;
    margin: 0 auto;
    text-align: left;
    max-width: 100%;
    overflow: hidden;
    display: flex;
    word-wrap: normal;
    word-break: break-all;
    white-space: initial;
  }
}

.multiline-ellipsis {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow-wrap: anywhere;
  white-space: normal;

  @for $i from 1 to 10 {
    &.me-#{$i}:not(.small) {
      -webkit-line-clamp: #{$i} !important;
    }
  }

  &.me-0 {
    display: none !important;
  }
}

.split-wrapper {
  .split-item {
    .remove-item {
      position: absolute;
      display: none;
      top: -9px !important;
      right: -9px !important;
    }
  }

  &:hover {
    .remove-item {
      display: flex;
    }
  }
}

.hide-last-plus {
  .hide-last-plus, .hide-last-border {
    background: #FBFCFC;
    top: 5px;
    width: 30px;
    height: 80px;
    margin: 0 auto;
    z-index: 1;
    position: relative;
  }

  .hide-last-border {
    top: 0px;
    background: #FBFCFC;
  }

  .hide-last-plus {
    top: -75px;
    height: 40px;
    z-index: 9;
  }
}

// This defines the width of the column which includes spacing between columns. It was not possible to be done with paddings on the items because paddings were adding up.
.column-width {
  width: 100%;
  min-width: 393px;
  height: 10px;
  background: transparent;
}

.pill {
  display: inline-flex;
  align-items: center;
  cursor: default;
  border-radius: 9px;
  border: solid 1px $blackPrimary;
  background-color: $greyUltralight;
  color: $blackPrimary;
  padding: 0 7px 2px 7px;
  margin-right: 5px;
  font-size: 11px;
  font-weight: 500;
}

::v-deep .label span {
  display: inline-flex !important;
  align-items: center !important;
  border-radius: 9px !important;
  border: solid 1px $blackPrimary !important;
  background-color: $greyUltralight !important;
  color: $blackPrimary !important;
  padding: 0 7px 0px 7px !important;
  margin-right: 0px !important;
  font-size: 12px !important;
  font-weight: 500 !important;
}

.skeleton > .item-wrapper {
  .item {
    .icon {
      content: '';
      background-color: #edf0f2 !important;
      background-image: none !important;
      border: none !important;
      box-shadow: none !important;
    }

    .context {
      display: none !important;
    }

    .condition, .label, .sublabel {
      background-color: #edf0f2 !important;
      color: #edf0f2 !important;
      border-radius: 6px;
      height: 14px;
    }

    .condition {
      width: 40% !important;
    }

    .label {
      margin-top: 4px !important;
      width: 100% !important;
      ::v-deep * {
        visibility: hidden !important;
      }
    }

    .sublabel {
      width: 65% !important;
    }
  }
}

// Message style
::v-deep .message-wrapper {
  display: flex;
  // flex-direction: row-reverse;
  justify-content: center;
  margin-bottom: 0px;
  // padding: 0 40px;
  // cursor: default;

  .message-inner-wrapper {
    // max-width: 75%;
  }

  &:not(.media) .template-message-wrapper {
    width: unset !important;
  }

  .message {
    &.image, &.video {
      max-width: 150px;
    }

    * {
      line-height: 1.45;
    }

    p {
      white-space: pre-wrap;
      word-wrap: break-word;
    }

    .media-message .caption {
      white-space: pre-wrap;
      word-wrap: break-word;
    }
  }

  // width: fit-content;
  // max-width: 70%;
  // word-break: break-word;

  .message {
    position: relative;
    padding: 9px 12px 9px 12px;
    border-radius: 18px;
    font-size: 14px;
    font-weight: 400;
    color: $white;

    &.has-buttons {
      border-radius: 18px 18px 3px 3px;
    }

    .editor-tag {
      padding: 0px 6px;
      border-radius: 9px;
      border: solid 1px $white;
      background-color: #4190ed;
      font-size: 12px;
      font-weight: 500;
      color: $white;
      white-space: nowrap;

      &.deleted {
        font-weight: 400 !important;
        color: $redPrimary !important;
        border: solid 1px $redPrimary !important;
      }
    }

    a:not(.dropdown-item) {
      color: $white !important;
      text-decoration: underline;
    }

    &.image,
    &.video {
      padding: 0 !important;

      .media-message {
        border: 1px solid #dfeeff;
        border-radius: 18px;
      }
    }

    &.audio {
      .media-message {
        overflow: unset !important;

        .audio-player {
          padding: 0 !important;
        }
      }
    }

    &.document .media-file {
      .sb-icon .mask {
        background-color: $blackPrimary !important;
      }
    }

    span {
      word-break: break-all;

      img {
        height: 14px;
        position: relative;
        top: 2px;
      }
    }

    .media-message {
      .media-image {
        width: 150px !important;
        height: 150px !important;

          &.loading {
          position: absolute;
          top: 0;
          background: #dfeeff;
        }
      }

      .media-file a {
        padding: 0 !important;
      }

      .audio-player {
        background-color: #dfeeff;
      }
    }
  }

  &.inbound {
    flex-direction: row;

    .sort-handler {
      right: unset;
      left: -28px;
    }

    .action-buttons {
      right: -37px;
      left: unset;

      .sb-icon {
        margin-left: 0;
        margin-right: 6px;
      }
    }

    .message {
      background-color: #edf0f2;

      .dropdown.b-dropdown {
        display: inline-block;
        vertical-align: baseline;

        span {
          vertical-align: baseline;
        }
      }

      .message-scope {
        font-size: 14px;
        font-weight: 400;
        color: $blackUltralight;
        text-decoration: underline !important;

        &:hover {
          cursor: pointer !important;
          color: $blackPrimary;
        }
      }
    }
  }

  &.outbound {
    .message {
      background-color: $bluePrimary;
    }
  }

  .message-button {
    padding: 6px 18px;
    border-radius: 3px;
    border: 1px solid #b1cff2;
    background-color: $white;
    color: $bluePrimary;
    margin-top: 3px;
    font-size: 14px;
    font-weight: 400;

    &:last-of-type {
      border-radius: 3px 3px 18px 18px;
    }
  }
}
</style>
